import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import type { Login, PassRecovery } from 'features/login/utils';
import { setToken } from 'store/slices/user-slice';

import type {
	CheckToken,
	CheckTokenResponse,
	ConfirmEmailRequest,
	ConfirmEmailResponse,
	ConfirmPass,
	ResetPass,
} from '../types/common';

const BASE_URL = process.env.REACT_APP_ENDPOINT as string;

export const authApi = createApi({
	reducerPath: 'authApi',
	baseQuery: fetchBaseQuery({
		baseUrl: `${BASE_URL}`,
	}),
	endpoints: (build) => ({
		loginUser: build.mutation<{ accessToken: string; status: string }, Login>({
			query: (queryArg) => ({
				url: `/api/public/auth`,
				method: 'POST',
				body: queryArg,
				credentials: 'include',
			}),
			async onQueryStarted(args, { dispatch, queryFulfilled }) {
				try {
					const { data } = await queryFulfilled;
					localStorage.setItem('userToken', data.accessToken);

					dispatch(setToken(data.accessToken));
				} catch (error) {
					console.log(error);
				}
			},
		}),
		userPassRecovery: build.mutation<null, PassRecovery>({
			query: (queryArg) => ({
				url: `/api/public/ask-reset-password` + '?email=' + queryArg.email,
				method: 'POST',
				credentials: 'include',
			}),
		}),
		userCheckToken: build.query<CheckTokenResponse, CheckToken>({
			query: (queryArg) => ({
				url: `/api/public/touch-token` + '?md5token=' + queryArg.token,
				method: 'POST',
				credentials: 'include',
			}),
		}),
		userResetPass: build.mutation<null, ResetPass>({
			query: (queryArg) => ({
				url: `/api/public/confirm-reset-password`,
				method: 'POST',
				body: queryArg,
				credentials: 'include',
			}),
		}),
		userConfirmPass: build.mutation<null, ConfirmPass>({
			query: (queryArg) => ({
				url: `/api/public/confirm-registration`,
				method: 'POST',
				body: queryArg,
				credentials: 'include',
			}),
		}),
		userConfirmEmail: build.query<ConfirmEmailResponse, ConfirmEmailRequest>({
			query: (queryArg) => {
				console.log('Отправка запроса с токеном:', queryArg.token);
				return {
					url: `/api/public/confirm-email` + '?token=' + queryArg.token,
					method: 'POST',
					credentials: 'include',
				};
			},
			async onQueryStarted(args, { queryFulfilled }) {
				try {
					const { data } = await queryFulfilled;
					localStorage.setItem('userToken', data.token);
				} catch (error) {
					console.log(error);
				}
			},
		}),
		confirmConsentPatient: build.query({
			query: (queryArg) => ({
				url: `/api/public/confirm-consent-patient` + '?token=' + queryArg,
				method: 'GET',
			}),
			async onQueryStarted(args, { queryFulfilled }) {
				try {
					const { data } = await queryFulfilled;
					console.log('Согласие получено');
				} catch (error) {
					console.log(error);
				}
			},
		}),
	}),
});

export const {
	useLoginUserMutation,
	useUserPassRecoveryMutation,
	useUserResetPassMutation,
	useUserCheckTokenQuery,
	useUserConfirmPassMutation,
	useLazyUserConfirmEmailQuery,
	useLazyConfirmConsentPatientQuery,
	useLazyUserCheckTokenQuery,
} = authApi;
